const openModal = ({commit}, modalType) => {
  commit('SET_MODAL', modalType)
}

const closeModal = ({commit}) => {
  commit('CLEAR_MODAL')
}

const setHighlightSearchWord = ({commit}, payload) => {
  commit('HIGHLIGHT_SEARCH', payload)
}

export default {
  openModal,
  closeModal,
  setHighlightSearchWord
}
